// authentication/roles.js
// Field staff only use the mobile app under /m. The backend refuses their
// tokens everywhere else (users.middleware.FieldStaffAccessMiddleware).
export const FIELD_STAFF_ROLE = 'field_staff';
export const FIELD_STAFF_HOME = '/m';
